import React from 'react';
import './PasswordChangedPopup.css';
import giftIcon from '../../images/shapes/password-changed 1.png';
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate

const PasswordChangedPopup = () => {
  const navigate = useNavigate(); // ✅ Initialize the hook

  const handleGoHome = () => {
    navigate("/"); // ✅ Navigate to /sign_in
  };

  return (
    <div className="reward-overlay" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <div className="reward-popup1">
        <h2 className="reward-title1" style={{ textAlign: 'center' }}>Password Changed!</h2>

        <img
          src={giftIcon}
          alt="Gift Icon"
          className="reward-icon"
          style={{ display: 'block', margin: '0 auto' }}
        />

        <p className="reward-message1" style={{ textAlign: 'center' }}>
          <span className="reward-points1">Your password has been reset successfully!</span>
        </p>

        <button onClick={handleGoHome} className="reward-button1" style={{ display: 'block', margin: '0 auto' }}>
          Back To Home
        </button>
      </div>
    </div>
  );
};

export default PasswordChangedPopup;
